import React, { useContext } from 'react';
import { arrayOf, func, object, oneOfType, shape, string } from 'prop-types';

import { Row, Col, Tab, Pills } from '@ajaibid/components';
import { AuthContext } from '@context/auth';
import { DayTradingContext } from '@context/daytrading';

function BottomPanelSectionTab(props) {
  const { instrumentTab, sectionTab, setSectionTab, activePills, setActivePills } = props;

  const { mtActive } = useContext(AuthContext);
  const { dtActive } = useContext(DayTradingContext);

  const filterPills = (menu) => {
    if (!dtActive && !mtActive) {
      return menu.label !== 'Day Trading' && menu.label !== 'Margin';
    }
    if (!dtActive) {
      return menu.label !== 'Day Trading';
    }
    if (!mtActive) {
      return menu.label !== 'Margin';
    }
    return true;
  };

  return (
    <>
      <Tab
        size="lg"
        tabOptions={instrumentTab.tableTab}
        activeTab={sectionTab}
        setActiveTab={setSectionTab}
      />
      <Row gutters={2} padding="12px">
        {sectionTab.pills.filter(filterPills).map(
          (item) =>
            item.label !== null && (
              <Col key={item.label} size="auto">
                <Pills
                  size="lg"
                  active={activePills.label === item.label}
                  onClick={() => setActivePills(item)}
                >
                  {item.label}
                </Pills>
              </Col>
            )
        )}
      </Row>
    </>
  );
}

BottomPanelSectionTab.propTypes = {
  instrumentTab: shape({
    key: string,
    name: string,
    tableTab: arrayOf(object),
  }).isRequired,
  sectionTab: shape({
    key: string,
    name: string,
    pills: arrayOf(object),
  }).isRequired,
  setSectionTab: func.isRequired,
  activePills: shape({
    label: string,
    tableContent: oneOfType([object, func]),
  }).isRequired,
  setActivePills: func.isRequired,
};

export default BottomPanelSectionTab;
